<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>罚款列表</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入关键字"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="c-m-l-10" @click="doNew" v-if="osg.has('Forfeit,new')">
          新建罚款单
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            //osg.export('forfeit', {
            // 'regex:name|string#or': searchValue,
            // 'regex:phone|string#or': searchValue,
            // 'regex:email|string#or': searchValue
            //})
            osg.doExport(
              {
                'in:state|integer#and': 1,
                'regex:orgName|string#or': searchValue,
                'regex:forfeitNum|string#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'forfeit',
                title: '罚款列表'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh && extFields.length"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <template v-if="osg.has('Forfeit,audit') && scope.row.forfeitState == -1">
                    <el-dropdown-item @click.native="handleReview('-2', scope.row)">
                      申诉成功
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="handleReview('1', scope.row)">
                      申诉失败
                    </el-dropdown-item>
                  </template>
                  <!-- <el-dropdown-item
                v-if="scope.row.forfeitState == 0"
                @click="handleAppeal(scope.row)"
              >
                申诉
              </el-dropdown-item> -->
                  <template v-if="osg.has('Forfeit,operation') && scope.row.forfeitState == 0">
                    <el-dropdown-item @click.native="handleReview('-1', scope.row)" divided>
                      申诉
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="handleReview('1', scope.row)">
                      确认
                    </el-dropdown-item>
                  </template>
                  <!-- v-if="scope.row.forfeitState != 0" -->
                  <!-- <el-dropdown-item @click="getLog(scope.row)">
                查看日志
              </el-dropdown-item> -->
                  <el-dropdown-item
                    v-if="scope.row.forfeitState == -1 || scope.row.forfeitStatef1Reason"
                    @click.native="
                      banSave = true;
                      handleAppeal(scope.row);
                    "
                    divided
                  >
                    查看申诉信息
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      scope.row.forfeitState != 1 &&
                        scope.row.forfeitState != -2 &&
                        osg.has('Forfeit,edit')
                    "
                    @click.native="
                      formData = $util.deepCopy(scope.row);
                      formData.type = String(formData.type);
                      openForm = true;
                    "
                  >
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      scope.row.forfeitState != 1 &&
                        scope.row.forfeitState != -2 &&
                        osg.has('Forfeit,edit')
                    "
                    @click.native="doEdit(scope.row)"
                    divided
                  >
                    修改罚款金额
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      (scope.row.forfeitState == 1 || scope.row.forfeitState == -2) &&
                        osg.has('Forfeit,Review')
                    "
                    @click.native="handleReview(0, scope.row, true)"
                    divided
                  >
                    反审
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      scope.row.forfeitState != 1 &&
                        scope.row.forfeitState != -2 &&
                        osg.has('Forfeit,remove')
                    "
                    @click.native="doRemove(scope.row)"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

          <c-table :fields="extFields">
            <template slot="name">
              <el-table-column label="姓名" width="120" fixed show-overflow-tooltip prop="name">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="$router.push({ path: `/contact/${scope.row._id}` })"
                    type="text"
                  >
                    {{ scope.row.name }}
                  </el-button>
                </template>
              </el-table-column>
            </template>
            <template slot="sourceTypeCode">
              <el-table-column label="编号" width="180" prop="sourceTypeCode">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="
                      $router.push({
                        path:
                          scope.row.sourceType == 'WorkOrder'
                            ? `/Flow/workOrder/${scope.row.sourceTypeId}`
                            : `/${scope.row.sourceType}/${scope.row.sourceTypeId}`
                      })
                    "
                    type="text"
                  >
                    {{ scope.row.sourceTypeCode }}
                  </el-button>
                </template>
              </el-table-column>
            </template>
          </c-table>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="新建罚款单"
      :visible.sync="openForm"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="formData"
        :fields="forfeitFields"
        :upload="upload"
        :options="options"
        ref="form"
        @changeForm="osg.changeForm"
        labelWidth="120px"
      >
        <el-form-item slot="forfeitRule">
          <el-select v-model="formData.exts.forfeitRule" clearable filterable>
            <template v-for="(item, i) in options.forfeitRule">
              <el-option
                :key="i"
                v-if="
                  !formData.exts.forfeitType
                    ? true
                    : formData.exts.forfeitType == item.type
                    ? true
                    : false
                "
                @click.native="
                  formData.forfeitAmount = item.forfeitAmount;
                  $forceUpdate();
                "
                :label="item.name"
                :value="item._id"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
      </c-form>
      <div slot="footer" v-if="!banSave">
        <el-button type="primary" @click="doSave()">
          确 定
        </el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="申诉表单"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="formData"
        :fields="appealExtFields"
        :upload="upload"
        :options="options"
        ref="form"
        @changeForm="osg.changeForm"
      >
        <template slot="complaintImg">
          <el-upload
            :class="{
              'c-upload-maxLimit': banSave
            }"
            :action="upload.url"
            :data="upload.data"
            :file-list="formData.exts['complaintImg']"
            multiple
            list-type="picture-card"
            :limit="10"
            :on-exceed="osg.uploadExceed"
            :before-remove="() => !banSave"
            :before-upload="
              file => {
                return osg.beforeUpload(file, 'image');
              }
            "
            :on-success="
              (response, file, fileList) => {
                return (formData.exts['complaintImg'] = osg.uploadSuccess(
                  response,
                  file,
                  fileList,
                  'complaintImg',
                  true
                ));
              }
            "
            :on-error="osg.uploadError"
            :on-remove="
              (file, fileList) => {
                return (formData.exts['complaintImg'] = osg.beforeRemove(
                  file,
                  fileList,
                  'complaintImg',
                  formData.exts['complaintImg']
                ));
              }
            "
            :on-preview="osg.uploadPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :modal="false" custom-class="dialog-img" :visible.sync="upload.dialogVisible">
            <img width="100%" :src="upload.dialogImageUrl" />
          </el-dialog>
        </template>
        <template slot="complaintFiles">
          <el-upload
            :class="{
              'c-upload-maxLimit': banSave
            }"
            :action="upload.url"
            :data="upload.data"
            :file-list="formData.exts['complaintFiles']"
            multiple
            list-type="picture-card"
            :limit="10"
            :on-exceed="osg.uploadExceed"
            :before-remove="() => !banSave"
            :before-upload="
              file => {
                return osg.beforeUpload(file);
              }
            "
            :on-success="
              (response, file, fileList) => {
                return (formData.exts['complaintFiles'] = osg.uploadSuccess(
                  response,
                  file,
                  fileList,
                  'complaintFiles',
                  true
                ));
              }
            "
            :on-error="osg.uploadError"
            :on-remove="
              (file, fileList) => {
                return (formData.exts['complaintFiles'] = osg.beforeRemove(
                  file,
                  fileList,
                  'complaintFiles',
                  formData.exts['complaintFiles']
                ));
              }
            "
            :on-preview="osg.uploadPreview"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div
              slot="file"
              slot-scope="{ file }"
              class="c-w-a c-h-1 c-flex c_flex_center"
              style="background: #f2f2f2;"
            >
              <label class="el-upload-list__item-status-label">
                <i class="el-icon-upload-success el-icon-check"></i>
              </label>
              <span>
                <i class="el-icon-document"></i>

                <span style="display:none">{{ file }}</span>
                {{
                  typeof file.name == 'string'
                    ? file.name.slice(file.name.lastIndexOf('.') + 1) + '文件'
                    : file.url.slice(file.url.lastIndexOf('.') + 1) + '文件'
                }}
              </span>
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-delete" @click="osg.uploadPreview(file, this)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  class="el-upload-list__item-delete"
                  @click="
                    (file, fileList) => {
                      return (formData.exts['complaintFiles'] = osg.beforeRemove(
                        file,
                        fileList,
                        'complaintFiles',
                        formData.exts['complaintFiles']
                      ));
                    }
                  "
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </template>
      </c-form>
      <div slot="footer" v-if="!banSave">
        <el-button
          type="primary"
          @click="
            () => {
              if (osg.validate())
                changeState({ flag: -1, memo: formData.forfeitStatef1Reason }, formData);
            }
          "
        >
          确 定
        </el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="修改金额"
      :visible.sync="openForfeitAmount"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="formData" ref="formData" label-width="120px" label-position="left">
        <el-form-item label="罚款金额" prop="forfeitAmount">
          <el-input
            type="number"
            v-model="formData.forfeitAmount"
            placeholder="罚款金额"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave()">
          确 定
        </el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="日志记录"
      :visible.sync="openLogDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
          <div class="activity-card-header">
            <span class="c-font-500">
              <i class="el-icon-monitor c-w-30"></i>
              {{ log.title }}
            </span>
            <span>{{ log.createTime }}</span>
          </div>
          <div class="activity-card-content">
            {{ log.content }}
          </div>
          <div class="activity-card-footer">
            <span>操作人：{{ log.createUserName }}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="openLogDetail = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Templates from '../Templates.vue';
export default {
  activated() {
    window.$this = this;
  },
  components: { Templates },
  name: 'forfeits',
  data() {
    return {
      name: 'forfeit',
      fpi: {},
      searchValue: '',
      openForm: false,
      openDetail: false,
      formData: { exts: {} },
      extFields: [],
      forfeitFields: [], //罚款表单
      appealExtFields: [], //申诉表单
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {},
      state: '', //已归档 archived
      refresh: true, //表格刷新
      openLogDetail: false, // 申诉日志
      openForfeitAmount: false,
      log: { fpi: {} }, //日志
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      banSave: false //禁止提交
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  async mounted() {
    this.doInit();
    this.osg.getFields('forfeit', () => {
      for (let f of this.extFields) {
        //申诉表单的字段
        if (f.frontEndConfig.appeal) {
          this.appealExtFields.push(f);
        } else {
          this.forfeitFields.push(f);
        }
      }
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    // formatProvince(row, column, cellValue) {
    //   return this.osg.areaObj.province_list[cellValue];
    // },
    // formatCity(row, column, cellValue) {
    //   return this.osg.areaObj.city_list[cellValue];
    // },
    // formatDistrict(row, column, cellValue) {
    //   return this.osg.areaObj.county_list[cellValue];
    // },
    formatState(row, column, cellValue) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatLeadStatus(row, column, cellValue) {
      return this.osg.codelabel('leadStatus', cellValue);
    },
    formatLifecycleStage(row, column, cellValue) {
      return this.osg.codelabel('lifecycleStage', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.openForm = false;
      this.openForfeitAmount = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
      //   this.state = this.osg.param('state');
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|integer#and': 1,
        'regex:orgName|string#or': this.searchValue,
        'regex:forfeitNum|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/forfeit/query.do', params, res => {
        this.refresh = false;
        this.fpi = res;
        this.refresh = true;
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openForm = true;
    },
    // doEdit(row) {
    //   var row = this.$util.deepCopy(row);
    //   this.$util.renderExtField(this.extFields, row);
    //   this.formData = row;
    //   this.openDetail = true;
    // },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openForfeitAmount = true;
    },
    doSave() {
      // this.$util.saveExtField(this.extFields, this.formData);
      if (this.osg.validate()) {
        this.$util.saveFormatExtField(this.extFields, this.formData);

        this.osg.ajax('basic/forfeit/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doRemove(row) {
      this.osg.confirm(`是否确认删除罚款单？编号：${row.forfeitNum}`, () => {
        row.state = -1;
        this.osg.ajax('basic/forfeit/upsert.do', { data: JSON.stringify(row) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('删除成功！');
        });
      });
    },
    //审核
    handleReview(flag, row, changeState) {
      // handleAppeal
      if (flag == -1) {
        this.banSave = false;
        this.handleAppeal(row); //打开申诉表单
      } else {
        if (changeState) {
          if (flag == 0) {
            this.osg.confirm('确定反审吗？', () => {
              this.changeState({ flag, memo: row.forfeitStatef1Reason }, row); //修改状态
            });
          } else {
            this.changeState({ flag, memo: row.forfeitStatef1Reason }, row); //修改状态
          }
          return;
        }
        row = this.$util.deepCopy(row);
        this.$prompt('请输入审核批语', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: flag == '-2' ? null : /\S/,
          inputErrorMessage: '审核批语不能为空',
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(({ value }) => {
            row.forfeitState = flag;
            row.remark = value;
            this.osg.ajax('basic/forfeit/upsert.do', { data: JSON.stringify(row) }, res => {
              this.doInit();
              this.getData();
              this.osg.toast('操作成功！');
            });
            // this.changeState({ flag, memo: this.formData.forfeitStatef1Reason }, row); //修改状态
          })
          .catch(() => {
            //   this.osg.toast('取消审核', 'info');
          });
      }
    },
    //修改状态
    changeState(option, row) {
      this.$util.saveFormatExtField(this.extFields, row);
      this.osg.ajax(
        'basic/forfeit/changeState.do',
        {
          state: option.flag,
          id: row._id,
          memo: option.memo,
          exts: JSON.stringify(row.exts)
        },
        res => {
          this.doInit();
          this.getData();
          this.osg.toast('操作成功！');
        }
      );
    },
    //申诉
    handleAppeal(row) {
      this.$util.renderExtField(this.extFields, row);
      this.openDetail = true;
      this.formData = this.$util.deepCopy(row);
      console.log(row);
    },
    /**
     * 日志
     */
    getLog(row) {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: row._id,
          smodule: 'forfeit',
          _all: '1',
          // 'regex:content|string#or': this.log.searchValue,
          // 'gte:createTime|datetime#and': this.log.searchDate[0],
          // 'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
          this.openLogDetail = true;
        },
        { noload: true }
      );
    }
    // doEnable(id) {
    //   this.osg.ajax('basic/forfeit/enable/' + id + '.do', null, () => {
    //     this.getData();
    //     this.osg.toast('操作成功！');
    //   });
    // },
    // doDisable(id) {
    //   this.osg.ajax('basic/forfeit/disable/' + id + '.do', null, () => {
    //     this.getData();
    //     this.osg.toast('操作成功！');
    //   });
    // },
    // doArchive(row, msg) {
    //   this.osg.confirm(`是否确认${msg}客户 ${row.name}？`, () => {
    //     this.osg.ajax('basic/forfeit/archive/' + row._id + '.do', null, () => {
    //       this.getData();
    //       this.osg.toast(`已${msg}客户 ${row.name}`);
    //     });
    //   });
    // }
  }
};
</script>
<style>
.c-upload-maxLimit .el-icon-delete {
  display: none;
}
.c-upload-maxLimit .el-icon-close-tip {
  display: none !important;
}
</style>
